import React, {Component} from 'react'
import ReCAPTCHA from "react-google-recaptcha";

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class ContactForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      contact_email: '',
      contact_number: '',
      enquiry: '',
      result: '',
      msg: ''
    };
    this.reCaptchaElement = React.createRef();
    this.form = React.createRef();
  }

  handleChange = e => {
    this.setState({[e.target.name]: e.target.value})
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false;

    // Check if reCAPTCHA has been successfully completed
    if (!this.reCaptchaElement.current.getValue()) {
      return false;
    }

    fetch("https://hooks.zapier.com/hooks/catch/3298056/3ceh7ha/", {
      method: "POST",
      headers: {"Content-Type": "application/x-www-form-urlencoded"},
      body: encode({
        "form-name": this.form.current.getAttribute("name"),
        ...this.state
      })
    })
      .then(() => {
        this.setState({result: 'success', msg: ''})
      })
      .catch(error => this.setState({result: 'fail', msg: error}))
  }

  render() {
    let props = {
      ref: this.form,
      name: 'Contact',
      className: 'form',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === 'success')
      return (
        <p className='contact__success'>Thanks for getting in contact with us.<br/> A member of our team will be in
          touch soon.</p>)

    return (
      <form {...props}>
        <div className='form__row form__row--double'>
          <div className='form__input'>
            <label>First Name</label>
            <input type='text' name='first_name' placeholder='Enter your First Name' onChange={this.handleChange} required/>
          </div>
          <div className='form__input'>
            <label>Last Name</label>
            <input type='text' name='last_name' placeholder='Enter your Last Name' onChange={this.handleChange} required/>
          </div>
        </div>
        <div className='form__row form__row--double'>
          <div className='form__input'>
            <label>Contact Email</label>
            <input type='email' name='contact_email' placeholder='Enter your Contact Email' onChange={this.handleChange} required/>
          </div>
          <div className='form__input'>
            <label>Contact Number</label>
            <input type='text' name='contact_number' placeholder='Enter your Contact number' onChange={this.handleChange} required/>
          </div>
        </div>
        <div className='form__row'>
          <label>How can we help?</label>
          <textarea name='enquiry' placeholder='Your message' onChange={this.handleChange}/>
        </div>
        <div className='form__row'>
          <ReCAPTCHA
            ref={this.reCaptchaElement}
            sitekey={`6LebuMwpAAAAABMbnw8U9Zq9IZQJiUrYT5gI9dPl`}
          />
        </div>
        <div className='form__row form__row--submit'>
          <button type='submit' className='btn btn--green'>Send Enquiry</button>
        </div>
      </form>
    )
  }
}

export default ContactForm